<template>
  <div
    ref="wrap"
    class="infinite-scroll-wrap"
  >
    <slot
      :items="items"
      :modelIds="modelIds"
      :isLoading="isLoading"
    />
    <!-- <DotLoading v-if="isLoading" /> loading skeleton做在外面-->
  </div>
</template>
<script>
export default {
  name: "WsInfiniteScrollWrap001",
  props: {
    windowTotleHeight: {
      type: Number,
      default: 0,
    },
    scrollPosition: {
      type: Number,
      default: 0,
    },
    modelName: {
      //Audit
      type: String,
      default: "",
    },
    modelParent: {
      //factory,factoryId
      type: String,
      default: "",
    },
    params: {
      //{search:''}
      type: Object,
      default() {
        return {};
      },
    },
    parentLayers: {
      //[{name:'system_classes'},{name:'system_subclasses}]
      type: Array,
      default() {
        return [];
      },
    },
    parentModels: {
      //{system_classes:[{id:1,name:"",system_subclasses:[]}],system_subclasses:[{id:1,id:2}]}
      type: Object,
      default() {
        return {};
      },
    },
    orderRules: {
      //{ order_by: "record_at",
      //   order_way: "desc",
      // };
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    C_params: {},
    items: [],
    isLoading: false, //loading skeleton 做在外面
    page: 1,
    lastPage: 1,
    C_parentLayers: {},
    C_parentModels: {},
    isStart: false,
    modelIds: {}, //{system_classes: 10, system_subclasses: 26}
  }),
  watch: {
    scrollPosition: {
      deep: true,
      async handler() {
        try {
          if (!this.$refs.wrap) return;
          let element = this.$refs.wrap.getBoundingClientRect();
          if (
            element.height + element.y - 100 <= this.windowTotleHeight &&
            !this.isLoading
          ) {
            if (this.parentLayers) {
              await this.$_scrollFetch(
                this.C_parentLayers,
                this.parentModels,
                this.parentLayers
              );
            } else {
              this.isLoading = true;
              await this.$_loadNextPage();
              this.isLoading = false;
            }
          }
        } catch (error) {
          alert(error)
        }
      },
    },
    modelName: {
      deep: true,
      immediate: true,
      async handler() {
        try {
          if (this.isLoading) return;
          await this.$_resetFetchData();
        } catch (error) {
          alert(error)
        }
      },
    },
    parentModels: {
      deep: true,
      immediate: true,
      async handler() {
        try {
          if (
            (this.parentLayers &&
            this.parentLayers.length &&
            this.parentModels[this.parentLayers[0].name].length === 0) ||
            this.isLoading
          ) return;
          await this.$_resetFetchData();
        } catch (error) {
          alert(error)
        }
      },
    },
    isLoading: {
      handler(newVal){
        this.$emit("loading", newVal)
      },
      immediate: true,
    }
  },
  methods: {
    $_getModelIds(C_modelIndexs, C_modelObject, parentNameLayers) {
      //得到依序送出得條件
      const _modelIds = {};
      parentNameLayers.forEach((parentNameLayer) => {
        const _modelName = parentNameLayer.name;
        const _tarModelId = this.$_getTargetModelId(
          C_modelIndexs,
          C_modelObject,
          parentNameLayers,
          _modelName
        );
        _modelIds[_modelName] = _tarModelId;
      });
      return _modelIds;
    },
    $_getTargetModelId(
      C_modelIndexs,
      C_modelObject,
      parentNameLayers,
      modelName
    ) {
      const targetLayerIndex = parentNameLayers.findIndex((e) => {
        return e.name == modelName;
      });
      let targerObject = C_modelObject;
      for (let index = 0; index <= targetLayerIndex; index++) {
        const _modelName = parentNameLayers[index].name;
        const _targetIndex = C_modelIndexs[_modelName];
        const _items = targerObject[_modelName];
        if (!_targetIndex && _targetIndex !== 0) return;
        if (_items.length === 0) return;
        targerObject = _items[_targetIndex];
      }
      if (!targerObject) {
        return;
      }
      return targerObject.id;
    },
    $_setParams() {
      this.C_params = { ...this.params };
    },
    $_setParentModels() {
      // let this.C_parentModels = this.parentModels
      for (let prop in this.parentModels) {
        this.C_parentModels[prop] = this.parentModels[prop];
      }
    },
    $_setParentLayers() {
      this.parentLayers.forEach((layer) => {
        this.$set(this.C_parentLayers, layer.name, 0);
        this.C_parentLayers[`pre_${layer.name}`] = -1;
      });
    },
    async $_resetFetchData() {
      try {
        this.isLoading = true;
        this.items = [];
        this.$_setParentLayers();
        this.$_setParentModels();
        this.$_setParams();
        await this.$_fetchData();
        this.isLoading = false;
      } catch(error) {
        this.isLoading = false;
        alert(error)
      }
    },
    async $_fetchData() {
      if (!this.modelName || !this.modelParent) return;
      try {
        if (this.parentLayers) {
          if (
            !this.C_parentLayers ||
            !this.parentModels ||
            !this.parentLayers
          ) {
            return;
          }
          const modelLayers = this.$_getModelIds(
            this.C_parentLayers,
            this.parentModels,
            this.parentLayers
          );
          this.modelIds = modelLayers; //依序送條件（subclasses...)
        }
        const _params = {
          page: this.page,
          ...this.C_params,
          ...this.modelIds,
          ...this.orderRules,
        };
        this.parentLayers.forEach((layerItem) => {
          if (_params[layerItem.name]) {
            _params[layerItem.name] = _params[layerItem.name].toString();
          }
        });
        this.isLoading = true;
        const res = await this.$axios.get(
          `/${this.modelParent}${this.modelName}`,
          {
            params: _params,
          }
        );
        this.isLoading = false;
        this.items = [...this.items, ...res.data.data];
        this.items = this.$_removeDuplicatedItem(this.items);
        this.lastPage = res.data.meta.last_page;
        this.isStart = true;
        if (this.parentLayers && res.data.data.length <= 15) {
          await this.$_scrollFetch(
            this.C_parentLayers,
            this.parentModels,
            this.parentLayers
          );
        }
      } catch (err) {
        alert(err);
      }
    },
    async $_loadNextPage() {
      try {
        if (this.page < this.lastPage) {
          this.page += 1;
          await this.$_fetchData();
        }
      } catch (error) {
        alert(error)
      }
    },
    async $_scrollFetch(C_modelIndexs, C_modelObject, parentNameLayers) {
      try {
        if (this.page < this.lastPage) {
          this.page += 1;
          await this.$_fetchData();
          return;
        }
        const allIndex = parentNameLayers.length;
        for (let index = allIndex - 1; index >= 0; index--) {
          const targetLayerIndex = index;
          let targerObject = C_modelObject;
          let _modelName = "";
          let _targetIndex = 0;
          let _items = null;
          for (let index = 0; index <= targetLayerIndex; index++) {
            _modelName = parentNameLayers[index].name;
            _targetIndex = C_modelIndexs[_modelName];
            if (!targerObject[_modelName].length) return;
            _items = targerObject[_modelName];
            targerObject = _items[_targetIndex];
          }
          if (C_modelIndexs[_modelName] + 1 < _items.length) {
            this.C_parentLayers[_modelName] += 1;
            this.page = 1;
            this.parentLayers.forEach((layer, layerIndex) => {
              if (layerIndex > targetLayerIndex) {
                this.C_parentLayers[layer.name] = 0;
              }
            });
            await this.$_fetchData();
            return;
          }
        }
      } catch (error) {
        alert(error)
      }
    },
    $_removeDuplicatedItem(items) {
      return items.filter((item, index, arr) => {
        if (
          arr.findIndex((findItem) => {
            return findItem.id === item.id;
          }) === index
        ) {
          return item;
        }
      });
    },
  },
};
</script>
<style lang="scss">
</style>